



















import mixins from 'vue-typed-mixins';
import ProviderTypeForm from '@/components/provider/ProviderTypeForm.vue';
import ProviderUtils, { ServiceProviderType } from '../../utils/ProviderUtils';
export default mixins().extend({
  components: {
    ProviderTypeForm,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    type?: Partial<ServiceProviderType>;
  } {
    return {
      type: {
        name: this.$languageobj(),
      },
    };
  },
  methods: {
    async submit() {
      if (this.type) {
        try {
          this.$alert.hide('submit');

          await ProviderUtils.api.type.add(this.type as ServiceProviderType);
          await this.$router.push({ name: 'provider-type-list' });

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.type.name],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
